import type { SagaIterator } from 'redux-saga';
import { call, select } from 'redux-saga/effects';

import { PROJECTION } from 'constants/ApiConstants';
import { putAndWait } from 'modules/app/sagas';
import { fetchDealer } from 'modules/dealers/actions';
import { getSelectedDealer } from 'selectors/dealerSelectors';

export function* getDealer(): SagaIterator {
  const dealer = (yield select(getSelectedDealer)) as ReturnType<typeof getSelectedDealer>;
  if (dealer.projection === PROJECTION.CONFIG) {
    return dealer;
  }

  const { payload, error } = yield call(putAndWait, fetchDealer(dealer.id, { projection: PROJECTION.CONFIG }));
  if (error) {
    throw new Error(payload);
  }
  return payload;
}
